// Load critical CSS first
import "./src/normalize.css"
import "./src/style.css"

// Load fonts with font-display: swap
import "@fontsource/montserrat/400.css"
import "@fontsource/montserrat/700.css"
import "@fontsource/merriweather/400.css"
import "@fontsource/merriweather/700.css"

// Highlighting for code blocks - load after critical content
import "prismjs/themes/prism-tomorrow.min.css"

// Preload critical components
import React, { useEffect } from "react"
import { withPrefix } from 'gatsby'
import Layout from "./src/components/layout"

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    "This application has been updated. " +
    "Reload to display the latest version?"
  )
  if (answer === true) {
    window.location.reload()
  }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Track page views with analytics here if needed
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'YOUR_GA_TRACKING_ID', {
      page_path: location.pathname,
    })
  }
}

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

// Preload images in viewport
const addLazyLoading = () => {
  if (typeof window === 'undefined') return
  
  const lazyImages = [].slice.call(document.querySelectorAll('img[loading="lazy"]'))
  
  if ('loading' in HTMLImageElement.prototype) {
    // Native lazy loading is supported
    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.lazy-background'))
    
    lazyBackgrounds.forEach(lazyBackground => {
      lazyBackground.classList.add('lazy-background-loaded')
    })
  } else {
    // Fallback for browsers that don't support loading attribute
    let lazyImageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let lazyImage = entry.target
            lazyImage.src = lazyImage.dataset.src
            if (lazyImage.dataset.srcset) {
              lazyImage.srcset = lazyImage.dataset.srcset
            }
            lazyImage.classList.remove('lazy')
            lazyImageObserver.unobserve(lazyImage)
          }
        })
      },
      { rootMargin: '200px 0px' }
    )

    lazyImages.forEach(lazyImage => {
      lazyImageObserver.observe(lazyImage)
    })
  }
}

export const onInitialClientRender = () => {
  // Add any client-side initialization code here
  addLazyLoading()
}
